import { localGet } from '@/utils/common'
export function getUsernameByUserid (id) {
  const memberList = localGet('memberList')
  const item = memberList.find(item => item.id === id)
  return item ? item.imMemberName : ''
}
